import { render, staticRenderFns } from "./CardiomiopatieList.vue?vue&type=template&id=ec80ef30"
import script from "./CardiomiopatieList.vue?vue&type=script&lang=js"
export * from "./CardiomiopatieList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports